import { render, staticRenderFns } from "./IdProofModal.vue?vue&type=template&id=7113f3b8&scoped=true&"
import script from "./IdProofModal.vue?vue&type=script&lang=js&"
export * from "./IdProofModal.vue?vue&type=script&lang=js&"
import style0 from "./IdProofModal.vue?vue&type=style&index=0&id=7113f3b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7113f3b8",
  null
  
)

export default component.exports